import './BenchmarkModal.scss';

import React, { useState } from 'react';

import BaseModal from 'components/shared/Modal/BaseModal';
import { BenchmarkTooltipBody } from 'components/shared/Modal/BenchmarkModalContent';

const BenchmarkModal = ({ productType, modelNumber, flex = false }) => {
  const [isOpen, setOpen] = useState(false);

  const toggleOpen = () => setOpen(true);
  const toggleClose = () => setOpen(false);

  return (
    <BaseModal
      flex={flex}
      title="Model Benchmark"
      isOpen={isOpen}
      open={toggleOpen}
      close={toggleClose}
      disableFixed>
      <BenchmarkTooltipBody
        productType={productType}
        modelNumber={modelNumber}
      />
    </BaseModal>
  );
};

export default BenchmarkModal;
